import { render } from "./MfcInputContactsEntity.vue?vue&type=template&id=77a26450"
import script from "./MfcInputContactsEntity.vue?vue&type=script&lang=js"
export * from "./MfcInputContactsEntity.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__